module.exports = __webpack_public_path__ + "media/פטריה.0e3e7053.mp3";